<template>
  <div>
    <!-- <scroll-loader class="dash-loader" :loader-method="()=> {}" :loader-enable="!loaded"></scroll-loader> -->
    <div v-columns="{ columns: 1, breakpoints: { 780: 2 } }" class="audience columns-list">
      <div class="panel">
        <h2>{{ $t("DASHBOARD_AUDIENCE_CHARTS_COUNTRIES") }}</h2>
        <div class="countries">
          <div
            class="one-country"
            :key="index"
            v-for="(country, index) in topCountries"
          >
            <div class="m-chart">
              <div class="chart" :ref="`country${index}`"></div>
            </div>
            <span class="country-code" :title="country.name">{{
              country.name
            }}</span>
          </div>
        </div>
      </div>
      <div class="panel" v-if="filtrateByAgesCharts.VK.length">
        <div class="aud-header">
          <h2>{{ $t("DASHBOARD_AUDIENCE_CHARTS_AGES") }}</h2>
          <div
            :class="`soc-sea ${filtrateByAgesCharts.VK[0].colorName}`"
            v-if="filtrateByAgesCharts.VK.length == 1"
          >
            <span
              :class="`soc-ico soc-${filtrateByAgesCharts.VK[0].social.toLowerCase()}`"
            ></span>
            {{ filtrateByAgesCharts.VK[0].owner_name_medium }}
          </div>
          <div class="settings">
            <button
              @click="setByAgeSelector(type.value)"
              :class="isActiveByAgeClass(type.value)"
              :key="index"
              v-for="(type, index) in typesList"
            >
              {{ type.label }}
            </button>
          </div>
        </div>
        <div class="cont">
          <div class="metrics-list">
            <div>to 18</div>
            <div>18-21</div>
            <div>21-24</div>
            <div>24-27</div>
            <div>27-30</div>
            <div>30-35</div>
            <div>35-45</div>
            <div>45+</div>
          </div>
          <div class="m-chart">
            <div
              class="chart"
              :ref="`agesVK`"
            ></div>
          </div>
        </div>
      </div>
      <div class="panel" v-if="filtrateByAgesCharts.IGFB.length">
        <div class="aud-header">
          <h2>{{ $t("DASHBOARD_AUDIENCE_CHARTS_AGES") }}</h2>
          <div
            :class="`soc-sea ${filtrateByAgesCharts.IGFB[0].colorName}`"
            v-if="filtrateByAgesCharts.IGFB.length == 1"
          >
            <span
              :class="`soc-ico soc-${filtrateByAgesCharts.IGFB[0].social.toLowerCase()}`"
            ></span>
            {{ filtrateByAgesCharts.IGFB[0].owner_name_medium }}
          </div>
          <div class="settings">
            <button
              @click="setByAgeSelector(type.value)"
              :class="isActiveByAgeClass(type.value)"
              :key="index"
              v-for="(type, index) in typesList"
            >
              {{ type.label }}
            </button>
          </div>
        </div>
        <div class="cont">
          <div class="metrics-list">
            <div>13-17</div>
            <div>18-24</div>
            <div>25-34</div>
            <div>35-44</div>
            <div>45-54</div>
            <div>55-64</div>
            <div>65+</div>
          </div>
          <div class="m-chart">
            <div
              class="chart"
              :ref="`agesIGFB`"
            ></div>
          </div>
        </div>
      </div>
      <div
        class="panel heatmap"
        :key="index"
        v-for="(page, index) in filtrateByOnlineCharts"
      >
        <div class="aud-header">
          <h2>{{ $t("DASHBOARD_AUDIENCE_CHARTS_ONLINE") }}</h2>
          <div :class="`soc-sea ${page.colorName}`">
            <span :class="`soc-ico soc-${page.social.toLowerCase()}`"></span>
            {{ page.owner_name_medium }}
          </div>
        </div>
        <div class="m-chart">
          <div class="chart" :ref="`online${index}`"></div>
          <div
            class="heat-legend"
            :ref="`online-legend${index}`"
            :data-color-code="page.colorCode"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const countries = require("i18n-iso-countries");
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
import { mapGetters, mapMutations, mapActions } from "vuex";
import pageCharts from "@/models/page-charts";
import HeatMap from "@/models/charts/eheatMap";
import gorizontalColumns from "@/models/charts/egorizontal-columns";
import RadarOne from "@/models/charts/eradar-countries";
import i18n from '@/i18nSetup';
import columnsDirective from "@/directives/columnsDirective.js";
import { scheduleCharts } from "@/models/charts/echarts-touch";

export default {
  name: "Dash-audience-many",
  components: {},
  directives: {
    columns: columnsDirective
  },    
  computed: {
    ...mapGetters([
      "getAnalizedPages",
      "getUnionPagesData",
      "getSocialOfAdminPageInAnalize",
      "getAnalizedAdminPages",
    ]),
    locale() {
      return this.$locale.DASHBOARD.AUDIENCE_CHARTS;
    },
    filtrateByCountriesCharts() {
      return this.getAnalizedPages.filter(
        (page) => page.is_admin && page.audienceStats && page.audienceStats.countries
      );
    },
    filtrateByOnlineCharts() {
      return this.getAnalizedPages.filter(
        (page) =>
          page.social != "VK" &&
          page.is_admin &&
          page.audienceStats &&
          page.audienceStats.online_followers
      );
    },
    filtrateByAgesCharts() {
      return this.getAnalizedPages.reduce(
        (acc, page) => {
          const isVkAdminPageHasAgeStats =
            page.social == "VK" && 
            page.is_admin && 
            page.audienceStats && 
            page.audienceStats.sex_age;
          const isIgFbAdminPageHasAgeStats =
            (page.social == "IG" || page.social == "FB") &&
            page.is_admin &&
            page.audienceStats && 
            page.audienceStats.page_fans_gender_age;
          if (isVkAdminPageHasAgeStats) acc.VK.push(page);
          else if (isIgFbAdminPageHasAgeStats) acc.IGFB.push(page);
          return acc;
        },
        { VK: [], IGFB: [] }
      );
    },
    topCountries() {
      const pages = this.getAnalizedAdminPages.filter(
        (page) => page.audienceStats && page.audienceStats.countries
      );
      const data = pageCharts.countries(pages).map((d) => {
        if (d.code == "RU") return { ...d, name: "Russia" };
        if (d.code == "US") return { ...d, name: "USA" };
        if (d.code == "A1") return { ...d, name: "Anonymous" };
        if (d.code == "EU") return { ...d, name: "European Union" };

        const name = countries.getName(d.code, "en");
        if (name.length > 10) return { ...d, name: name.slice(0, 10) + "..." };
        return { ...d, name };
      });
      return data;
    },
  },
  data() {
    return {
      loaded: false,
      byCountrySelector: "All",
      byAgeSelector: "All",
      typesList: [
        { value: "All", label: i18n.t('AUDIENCE_ALL') },
        { value: "Men", label: i18n.t('AUDIENCE_MEN') },
        { value: "Women", label: i18n.t('AUDIENCE_WOMEN') },
      ],
    };
  },
  methods: {
    isActiveByCountryClass(type) {
      if (this.byCountrySelector == type) return "active";
      return "";
    },
    setByCountrySelector(type) {
      this.byCountrySelector = type;
    },
    isActiveByAgeClass(typeValue) {
      return this.byAgeSelector === typeValue ? "active" : "";
    },
    setByAgeSelector(typeValue) {
      this.byAgeSelector = typeValue;
      this._ageGen = (this._ageGen || 0) + 1;
      setTimeout(this.renderAgesCharts, 0);
    },
    refEl(name) {
      const ref = this.$refs[name];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    async renderAgesCharts() {
      const { VK, IGFB } = this.filtrateByAgesCharts;
      if (VK.length && this.refEl("agesVK")) {
        const data = pageCharts.ages(VK, this.byAgeSelector);
        if (this.charts.agesVK) this.charts.agesVK.dispose();
        this.charts.agesVK = await gorizontalColumns({
          ref: this.$refs.agesVK,
          data,
          pages: VK,
        });
      }
      if (IGFB.length && this.refEl("agesIGFB")) {
        const data = pageCharts.ages(IGFB, this.byAgeSelector);
        if (this.charts.agesIGFB) this.charts.agesIGFB.dispose();
        this.charts.agesIGFB = await gorizontalColumns({
          ref: this.$refs.agesIGFB,
          data,
          pages: IGFB,
        });
      }
    },
    renderCharts() {
      const renderId = (this._renderId = (this._renderId || 0) + 1);
      if (this._stopCharts) this._stopCharts();
      this.disposeAllCharts();
      this.charts.countries = [];
      this.charts.online = [];
      this.charts.agesVK = null;
      this.charts.agesIGFB = null;
      const jobs = [];

      const { VK, IGFB } = this.filtrateByAgesCharts;
      if (VK.length && this.refEl("agesVK")) {
        jobs.push({
          el: this.refEl("agesVK"),
          run: async () => {
            const gen = this._ageGen || 0;
            const chart = await gorizontalColumns({
              ref: this.$refs.agesVK,
              data: pageCharts.ages(VK, this.byAgeSelector),
              pages: VK,
            });
            if (this._renderId !== renderId || (this._ageGen || 0) !== gen) return;
            this.charts.agesVK = chart;
          },
        });
      }
      if (IGFB.length && this.refEl("agesIGFB")) {
        jobs.push({
          el: this.refEl("agesIGFB"),
          run: async () => {
            const gen = this._ageGen || 0;
            const chart = await gorizontalColumns({
              ref: this.$refs.agesIGFB,
              data: pageCharts.ages(IGFB, this.byAgeSelector),
              pages: IGFB,
            });
            if (this._renderId !== renderId || (this._ageGen || 0) !== gen) return;
            this.charts.agesIGFB = chart;
          },
        });
      }

      this.filtrateByOnlineCharts.forEach((page, index) => {
        const ref = this.$refs[`online${index}`];
        const chartRef = Array.isArray(ref) ? ref[0] : ref;
        if (!chartRef) return;
        jobs.push({
          el: chartRef,
          run: async () => {
            const chart = await HeatMap({
              ref: chartRef,
              page,
              refLegend: chartRef.nextSibling,
            });
            if (this._renderId !== renderId) {
              if (chart && chart.dispose) chart.dispose();
              return;
            }
            if (chart) this.charts.online[index] = chart;
          },
        });
      });

      const pages = this.getAnalizedAdminPages.filter(
        (page) => page.audienceStats && page.audienceStats.countries
      );
      const calculateTotal = this.topCountries.reduce((acc, val) => {
        pages.forEach((_, i) => {
          acc[`count_${i}`]
            ? (acc[`count_${i}`] += val[`count_${i}`])
            : (acc[`count_${i}`] = val[`count_${i}`]);
        });
        return acc;
      }, {});
      this.topCountries.forEach((country, index) => {
        const ref = this.$refs[`country${index}`];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (!el) return;
        jobs.push({
          el,
          run: async () => {
            const chart = await RadarOne({
              ref,
              maxValue: calculateTotal,
              country,
              pages,
            });
            if (this._renderId !== renderId) {
              if (chart && chart.chart && chart.chart.dispose) chart.chart.dispose();
              return;
            }
            this.charts.countries[index] = chart;
          },
        });
      });

      this._stopCharts = scheduleCharts(jobs, { batchSize: 3 });
    },
    disposeAllCharts() {
      if (this.charts.agesVK) {
        this.charts.agesVK.dispose();
      }
      if (this.charts.agesIGFB) {
        this.charts.agesIGFB.dispose();
      }
      if (this.charts.countries && this.charts.countries.length) {
        this.charts.countries.forEach(result => {
          if (result && result.chart && typeof result.chart.dispose === 'function') {
            result.chart.dispose();
          }
        });
      }
      if (this.charts.online && this.charts.online.length) {
        this.charts.online.forEach(chart => {
          if (chart && typeof chart.dispose === 'function') {
            chart.dispose();
          }
        });
      }
    }
  },
  created() {
    this.charts = {
      countries: [],
      agesVK: null,
      agesIGFB: null,
      online: [],
    };
  },
  mounted() {
    setTimeout(this.renderCharts, 0);
  },
  beforeDestroy() {
    this._renderId = (this._renderId || 0) + 1;
    if (this._stopCharts) this._stopCharts();
    setTimeout(this.disposeAllCharts, 0);
  },
};
</script>

<style></style>
